import { OrganizationApi } from '../openapi';
import { config } from './config';

export const OrganizationClient = new OrganizationApi(config);
